<mat-toolbar class="mat-elevation-z3" color="primary">
    <button mat-icon-button (click)="collapsed.set(!collapsed())">
        <mat-icon>menu</mat-icon>
    </button>
    <div class="logo">
        <img class="img" src="../assets/logo-sura.svg" alt="logo" />
    </div>
    <div class="mr-2 cerrar-sesion">
        <span class="usuario">{{nombreUsuario}}</span>
        <p-button
            icon="pi pi-sign-out"
            class="mr-2"
            text
            severity="secondary"
            (click)="cerrarSesion()"
            (keydown.enter)="$event.preventDefault(); cerrarSesion()"
            (keydown.space)="$event.preventDefault(); cerrarSesion()"
        />
    </div>
</mat-toolbar>

<mat-sidenav-container>
    <mat-sidenav opened mode="side" [style.width]="sidenavWidth()">
        <sura-menu [collapsed]="collapsed()"></sura-menu>
    </mat-sidenav>
    <mat-sidenav-content class="content" [style.margin-left]="sidenavWidth()">
        <!-- Dialog de Confirmación (con dos botones) -->
        <p-confirmdialog #cd>
            <ng-template pTemplate="headless" let-message let-onAccept="onAccept" let-onReject="onReject">
                <div class="dialog-container">
                    <div class="dialog-icon">
                        <i class="pi pi-question"></i>
                    </div>
                    <h2 class="dialog-header">{{ message.header }}</h2>
                    <p class="dialog-message">{{ message.message }}</p>
                    <p-divider />
                    <div class="dialog-buttons">
                        <p-button label="No" icon="pi pi-times" [raised]="true" [rounded]="true" severity="secondary"
                            (onClick)="onReject()"
                            (keydown.enter)="$event.preventDefault(); onReject()"
                            (keydown.space)="$event.preventDefault(); onReject()"></p-button>
                        <p-button label="Si" icon="pi pi-check-circle" [raised]="true" [rounded]="true"
                            (onClick)="onAccept()"
                            (keydown.enter)="$event.preventDefault(); onAccept()"
                            (keydown.space)="$event.preventDefault(); onAccept()"></p-button>
                    </div>
                </div>
            </ng-template>
        </p-confirmdialog>

        <!-- Dialog de Alerta (con un solo botón) -->
        <p-confirmdialog key="alert-dialog">
            <ng-template pTemplate="headless" let-message let-onAccept="onAccept">
                <div class="dialog-container">
                    <div class="dialog-icon alert-icon">
                        <i class="pi pi-exclamation-triangle"></i>
                    </div>
                    <h2 class="dialog-header">{{ message.header }}</h2>
                    <p class="dialog-message">{{ message.message }}</p>
                    <p-divider />
                    <div class="dialog-buttons">
                        <p-button label="Aceptar" icon="pi pi-check" [raised]="true" [rounded]="true" severity="primary"
                            (onClick)="onAccept()"
                            (keydown.enter)="$event.preventDefault(); onAccept()"
                            (keydown.space)="$event.preventDefault(); onAccept()"></p-button>
                    </div>
                </div>
            </ng-template>
        </p-confirmdialog>

        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>

<p-toast position="bottom-right" [preventOpenDuplicates]="true">
    <ng-template pTemplate="message" let-message>
        @switch (message.severity) {
            @case ('success') {
                <i class="p-toast-message-icon pi pi-check" aria-hidden="true"></i>
            }
            @case ('warn') {
                <i class="p-toast-message-icon pi pi-exclamation-triangle" aria-hidden="true"></i>
            }
            @case ('error') {
                <i class="p-toast-message-icon pi pi-times-circle" aria-hidden="true"></i>
            }
            @default {
                <i class="p-toast-message-icon pi pi-info-circle" aria-hidden="true"></i>
            }
        }
        <div class="p-toast-message-text">
            <div class="p-toast-summary">{{ message.summary }}</div>
            @if (causasToast(message); as causas) {
                <ul class="toast-causas">
                    @for (causa of causas; track $index) {
                        <li>{{ causa }}</li>
                    }
                </ul>
            } @else if (message.detail) {
                <div class="p-toast-detail">{{ message.detail }}</div>
            }
        </div>
    </ng-template>
</p-toast>